import { lazy } from "react";
import { Outlet, type RouteObject } from "react-router-dom";
import { ROUTES } from "./constants";
import { protectedRoute } from "./helpers";

const AdminLayout = lazy(
	() => import("../einstein/components/admin/layout/AdminLayout"),
);
const AdminPage = lazy(() => import("../einstein/components/admin/AdminPage"));
const AdminHowToPage = lazy(
	() => import("@/features/howto/components/admin/HowToAdminPage"),
);
const MethodologiesAdminPage = lazy(
	() =>
		import("@/features/methodologies/components/admin/MethodologiesAdminPage"),
);
const UsersPage = lazy(() => import("../einstein/components/admin/users"));
const CuriosityV2AdminRoute = lazy(
	() => import("@/features/curiosity-v2/admin/CuriosityV2AdminRoute"),
);
const NotFound = lazy(
	() => import("../einstein/components/common/errors/NotFound"),
);

export const adminRoute: RouteObject = {
	path: ROUTES.ADMIN,
	element: protectedRoute(
		<AdminLayout>
			<Outlet />
		</AdminLayout>,
	),
	children: [
		{
			path: "",
			element: <AdminPage />,
		},
		{
			path: "users",
			element: <UsersPage />,
		},
		{
			path: "curiosity",
			element: <CuriosityV2AdminRoute />,
		},
		{
			path: "curiosity-v2",
			element: <CuriosityV2AdminRoute />,
		},
		{
			path: "methodologies",
			element: <MethodologiesAdminPage />,
		},
		{
			path: "how-to",
			element: <AdminHowToPage />,
		},
		{
			path: "*",
			element: <NotFound />,
		},
	],
};
